
<template>
  <div class="ebms">
    <div class="main-top">
      <img src="../assets/img/main-title.jpg" alt="" />
    </div>
    <div class="main-content">
      <div class="main-title">
        <h1>系统简介</h1>
      </div>
      <div class="main-summary">
        <div class="summary-img">
          <img src="../assets/img/ebms-title.png" alt="" />
        </div>
        <div class="summary-text">
          <p>
            针对锂电池和铅酸电池组在充放电的运行过程中由于单体电池不均衡导致电池组达到电压阈值提前结束正常的充放电过程的现象进行管理，在电池组充放电时通过主动均衡的介入，保障正常电池单元工作在最优状态，保护落后电池单元不遭受过充过放，在延长电池组的供电时长同时也能增加电池单元使用寿命。EBMS在进行充放电的全过程管理时可以将电池组每一节电池的各项参数及时传递到监控平台，通过AI智能算法提醒用户对电池组做主动维护管理，及时更换性能不达标电池单元以保障整个应用系统的备电安全。同时，在对电池组的管理过程中，EBMS还可以实现电池组快速充电、消除电池单元极化等功能，从而扩大电池组的使用场景、延长电池单元的使用寿命。
          </p>
        </div>
      </div>
      <div class="main-title">
        <h1>核心功能</h1>
      </div>
      <div class="main-function">
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/zhudongjunheng.jpg" alt="" />
          </div>
          <div class="function-text">
            <div>主动均衡</div>
            <ul>
              <li>充电均衡</li>
              <li>放电均衡</li>
              <li>增加放电时长</li>
            </ul>
          </div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/shendujiance.png" alt="" />
          </div>
          <div class="function-text">
            <div>深度检测</div>
            <ul>
              <li>单节电池检测</li>
              <li>电池温度检测</li>
              <li>充放电检测</li>
            </ul>
          </div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/youhuachongdian.png" alt="" />
          </div>
          <div class="function-text">
            <div>优化充电</div>
            <ul>
              <li>分段充电</li>
              <li>变流充电</li>
              <li>均衡充电</li>
            </ul>
          </div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/zaixianherong.png" alt="" />
          </div>
          <div class="function-text">
            <div>在线核容</div>
            <ul>
              <li>分段充电</li>
              <li>变流充电</li>
              <li>均衡充电</li>
            </ul>
          </div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/dianchiyanshou.png" alt="" />
          </div>
          <div class="function-text">
            <div>电池延寿</div>
            <ul>
              <li>过充保护</li>
              <li>过放保护</li>
              <li>防极化保护</li>
            </ul>
          </div>
        </div>
        <div class="func-item">
          <div class="function-img">
            <img src="../assets/img/zhuangweibianjie.png" alt="" />
          </div>
          <div class="function-text">
            <div>装维便捷</div>
            <ul>
              <li>机架/外挂方式</li>
              <li>模块设计</li>
              <li>屏显及控制键</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main-title">
        <h1>产品参数</h1>
      </div>
      <div class="alarm-summary">
        <ul class="summary-tip">
          <li>1、电压采集精度：2mV；单节电压测量范围：0V至5V。</li>
          <li>2、电流采集精度：0.5A；电流测量范围：±200A。</li>
          <li>3、温度采集精度：0.5℃；温度测量范围：-50℃-120℃。</li>
          <li>4、SIM卡支持：移动、联通。</li>
          <li>5、支持电池类型：铅酸、磷酸铁锂、三元锂。</li>
          <li>6、支持电池节数：15-24节。</li>
          <li>
            7、设备功耗：<br/>
            （1）、接入系统后，关机状态：≦25mA@INPUT48.5V。<br/>
            （2）、接入系统后，开机运行状态：≧120mA@INPUT48.5V。
          </li>
          <li>
            8、尺寸及重量：<br/>
            （1）、常规版：外观尺寸：480mm*275mm*90mm；重量：约5.5Kg。<br/>
            （2）、简易版：外观尺寸：300mm*210mm*90mm；重量：约3.5Kg。
          </li>
          <li>9、工作条件：-10℃-50℃。</li>
          <li>10、存储条件：-20℃-70℃。</li>
        </ul>
      </div>
      <div class="gotoalarm" @click="goto">进入体验></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      map: {},
    };
  },
  mounted() {},
  methods: {
    goto() {
      window.open("http://weipucomm.cn:8066/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ebms {
  background-color: #f7f7f7;
  .main-top {
    margin: 1vh 0 0 0;
    height: 13vh;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .main-content {
    margin: 0 5vw;
    .main-title {
      border-bottom: 1px solid #ecedf1;
      overflow: hidden;
      height: 100px;
      h1 {
        background: url(../assets/img/red-line.png) no-repeat center bottom;
        font-weight: 700;
        width: 160px;
        line-height: 100px;
        margin: 0;
      }
    }
    .main-summary {
      display: flex;
      align-items: center;
      .summary-img {
        padding: 5vh 0;
        width: 30vw;
        img {
          width: 100%;
          height: auto;
        }
      }
      .summary-text {
        padding: 0 0 0 2vw;
        flex: 1;
        p {
          text-indent: 28px;
          line-height: 30px;
          font-size: 18px;
        }
      }
    }
    .main-function {
      display: flex;
      padding: 5vh 0;
      justify-content: space-around;
      flex-wrap: wrap;
      .func-item {
        width: 20vw;
        height: 26vw;
        display: flex;
        flex-flow: column;
        align-items: center;
        .function-img {
          height: 20vw;
          width: 15vw;
          display: flex;
          align-items: center;
          img {
            height: 20vh;
            width: 100%;
          }
        }
        .function-text {
          text-align: center;
          font-size: 24px;
          height: 10vw;
          width: 100%;
          div {
            padding: 2vh;
            margin: 0 2vw;
            background: skyblue;
            color: red;
            box-shadow: 2px 2px grey;
          }
          li {
            text-align: left;
            margin-left: 3vw;
          }
        }
      }
    }
    .alarm-summary {
      display: flex;
      padding: 5vh 0;
      .summary-tip {
        font-size: 20px;
        line-height: 35px;
      }
    }
    .gotoalarm {
      text-align: center;
      font-size: 30px;
      color: #dd4242;
      text-decoration: underline;
      line-height: 70px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ebms.vue